import { render, staticRenderFns } from "./DoughnutChartWithFiltersSection.vue?vue&type=template&id=40e3c2b0"
import script from "./DoughnutChartWithFiltersSection.vue?vue&type=script&lang=js"
export * from "./DoughnutChartWithFiltersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports